// removed by extract-text-webpack-plugin
module.exports = {"tabWrapper":"_1iL9GjuwAF-lXH4CQHpZ2d","photoWrapper":"_2gv-2HruXbqBJQuGyFBAPs","textWrapper":"_2cnHkU9D1oNF-P2-mIvAAm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TabPrivateBrokerage/TabPrivateBrokerage.scss
// module id = 1785
// module chunks = 0